import { addExportListener } from './exporters.util';

const reportWinnersExporter = async (
  records,
  fetchRelatedRecords,
  _dataProvider, _resource, additionData = {},
) => {
  const { date } = additionData;

  const brand = await fetchRelatedRecords(records, 'brand', 'brand');
  const currency = await fetchRelatedRecords(records, 'currency', 'currency');
  const game = await fetchRelatedRecords(records, 'gameId', 'game');

  const winnersForExport = records.map(data => {
    const result = {
      id: data.id,
      brand: brand[data.brand]?.name,
      gameId: game[data.gameId]?.gameId,
      playerId: data.playerId,
      nativeId: data.nativeId,
      winnings: data.winnings?.toString?.()?.replace?.('.', ','),
      betCount: data.betCount,
      betAmount: data.betAmount?.toString?.()?.replace?.('.', ','),
      wonAmount: data.wonAmount?.toString?.()?.replace?.('.', ','),
      currency: currency[data.currency]?.code,
      rtp: data.rtp?.toString?.()?.replace?.('.', ','),
    };

    return result;
  });

  addExportListener({
    dataList: winnersForExport,
    dateString: date,
    fileName: 'Winners Report',
  });
};

export default reportWinnersExporter;
